export function addDateMonths(date: string, month: number) {
  const newDate = new Date(date);
  return newDate.setMonth(newDate.getMonth() + month);
}
